import { render } from "./ResultTeam.vue?vue&type=template&id=489ee6bb&scoped=true"
import script from "./ResultTeam.vue?vue&type=script&lang=js"
export * from "./ResultTeam.vue?vue&type=script&lang=js"

import "./ResultTeam.vue?vue&type=style&index=0&id=489ee6bb&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489ee6bb"]])

export default __exports__